import { createSelector } from 'reselect';
const rootSelector = state => state.advancedDistributions;
export const advancedDistributionsSelector = createSelector(rootSelector, state => state.distributions);
export const advancedDistributionsLoadingSelector = createSelector(rootSelector, state => state.loading);